// ============================================================================
// TextFieldGroup.jsx — Corelia UI v1.2
// Gestion cohérente H/V basée sur FormLayout et theme.form
// ============================================================================
import React from "react";
import theme from "../../../styles/theme";
import TextField from "./TextField";

const TextFieldGroup = ({
  fields = [],              // [{ name, label, value, placeholder, error }]
  onChange,                 // (name, value) => {}
  orientation = "vertical", // "vertical" | "horizontal"
  disabled = false,
  width = "100%",
  style = {},
}) => {
  const isHorizontal = orientation === "horizontal";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: isHorizontal ? "row" : "column",
        alignItems: isHorizontal ? "flex-start" : "stretch",

        gap: isHorizontal ? theme.spacing.lg : theme.spacing.md,

        width,
        opacity: disabled ? 0.6 : 1,
        cursor: disabled ? "not-allowed" : "default",
        fontFamily: theme.form.label.fontFamily,
        marginBottom: theme.spacing.md,
        ...style,
      }}
    >
      {fields.map((field, index) => (
        <div
          key={field.name ?? index}
          style={{
            width: isHorizontal ? "100%" : "100%",
          }}
        >
          <TextField
            label={field.label}
            value={field.value}
            placeholder={field.placeholder}
            error={field.error}
            disabled={disabled}
            labelPosition={field.labelPosition ?? "left"}   // cohérent avec FormLayout
            labelWidth={field.labelWidth ?? null}
            align={field.align ?? "center"}
            width={"100%"}

            onChange={(e) =>
              !disabled && onChange(field.name, e.target.value)
            }
          />
        </div>
      ))}
    </div>
  );
};

export default TextFieldGroup;
